import React, { useState } from 'react';
import { Form, Input, Button, Card, Typography, message } from 'antd';
import { UserOutlined, LockOutlined, RobotOutlined } from '@ant-design/icons';
import { useAuth } from '@/hooks/useAuth';
import styles from '@/styles/pages/LoginPage.module.css';

const { Title, Text } = Typography;

const LoginForm = () => {
  const [form] = Form.useForm();
  const { login, isLoading } = useAuth();
  const [error, setError] = useState('');

  const onFinish = async (values) => {
    localStorage.removeItem('selectedCompany');
    localStorage.removeItem('methods');
    setError('');
    try {
      const success = await login(values.text, values.password);
      console.log('Success', success)
      if (success?.success) {
        message.success('Вход выполнен успешно!');
      } else {
        setError(success.error.detail || 'Неверный email или пароль');
      }
    } catch (error) {
      setError('Ошибка при входе. Попробуйте снова.');
    }
  };

  return (
    <div className={styles.loginPage}>
      <div className={styles.bgGradient}></div>
      <div className={styles.bgPattern}></div>

      <div className={styles.container}>
        <Card className={styles.loginCard} bordered={false}>
          <div className={styles.logoWrapper}>
            <div className={styles.logoIcon}>
              <RobotOutlined />
            </div>
            <Title level={2} className={styles.brandName}>DEV Assistant</Title>
            <Text className={styles.brandTagline}>Персональный помощник Alex</Text>
          </div>


          {error && (
            <div className={styles.errorAlert}>
              <span className={styles.errorIcon}>⚠️</span>
              <span>{error}</span>
            </div>
          )}

          <Form
            form={form}
            name="login"
            onFinish={onFinish}
            layout="vertical"
            size="large"
            className={styles.loginForm}
          >
            <Form.Item
              name="text"
              rules={[
                { required: true, message: 'Введите логин' },
              ]}
            >
              <Input
                prefix={<UserOutlined className={styles.inputIcon} />}
                placeholder="Email"
                autoComplete="username"
                className={styles.inputField}
              />
            </Form.Item>

            <Form.Item
              name="password"
              rules={[{ required: true, message: 'Введите пароль' }]}
            >
              <Input.Password
                prefix={<LockOutlined className={styles.inputIcon} />}
                placeholder="Пароль"
                autoComplete="current-password"
                className={styles.inputField}
              />
            </Form.Item>

            <Form.Item className={styles.formActions}>
              <Button
                type="primary"
                htmlType="submit"
                loading={isLoading}
                block
                size="large"
                className={styles.submitButton}
              >
                {isLoading ? 'Вход...' : 'Войти в систему'}
              </Button>
            </Form.Item>
          </Form>
        </Card>

        <div className={styles.copyright}>
          <Text className={styles.copyrightText}>
            © {new Date().getFullYear()} Alex Assistant. Все права защищены.
          </Text>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;